var exports = {
  "n": "xe533113f--516bdd--controls",
};

module.exports = exports;
